/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import logo from '../../Recursos/logo.svg'
import {Menu} from '@mui/icons-material'

const BarraCell = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 3, mb: -16.5,}}
        >

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img src={logo} width={120} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                <IconButton>
                    <Menu sx={{fill: '#fff'}}/>
                </IconButton>
            </Grid>

        </Grid>
    )

}
export default BarraCell    